<!-- 取消订单 -->
<template>
  <div id="">
    <el-radio-group v-model="subData.cancelReason">
      <div class="reason-item" v-for="item in reasonList" :key="item.name">
        <el-radio :label="item.name">{{ item.name }}</el-radio>
      </div>
    </el-radio-group>
    <div class="otherReason">
      <el-input
        type="textarea"
        :rows="3"
        placeholder="请输入取消订单的原因"
        v-model="otherReason"
      >
      </el-input>
    </div>
    <div class="dialog-footer" style="text-align: right">
      <el-button @click="clearDataAndClose()">取 消</el-button>
      <el-button class="btn-primary" @click="submitData">确 定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {
    cancelId: {}
  },
  data() {
    return {
      from: 1,
      textCount: 0,
      subData: {
        OrderId: "",
        userId: this.$util.getLocalStorage("userMsg").EmployeeId,
        cancelReason: "不想买了"
      },
      otherReason: "",
      reasonList: [
        { name: "不想买了" },
        { name: "有其他更好的选择" },
        { name: "商品质量信不过" },
        { name: "其他" }
      ]
    };
  },
  mounted() {},
  methods: {
    clearDataAndClose() {
      this.$emit("closeCancel");
    },
    resetFrom() {
      this.subData = {
        OrderId: "",
        userId: this.subData.userId,
        cancelReason: "不想买了"
      };
      this.otherReason = "";
    },
    submitData() {
      if (this.subData.cancelReason == "其他") {
        if (this.otherReason == "") {
          this.$util.warningMsg("请填写取消原因");
          return;
        } else {
          this.subData.cancelReason = this.otherReason;
        }
      }
      this.subData.OrderId = this.cancelId;

      this.$util
        .axiosPost({
          url: "/api/ShareInventory/CancelSGoodsPurchaseOrder",
          data: this.subData
        })
        .then(res => {
          this.$util.successMsg("已取消该订单");
          setTimeout(() => {
            this.$emit("closeCancel");
          }, 1000);
        })
        .catch(err => {});
    },
    count(e) {
      let value = e.detail.value;
      this.textCount = value.length;
      this.otherReason = value;
    },
    checkboxChange(e) {
      let value = e.detail.value;
      this.subData.cancelReason = value;
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-footer {
  padding-top: 20px;
}
.reason-item {
  padding-top: 20px;
}
.otherReason {
  padding-top: 20px;
}
</style>
